import { fontSizes } from "."

export default {
  body: 28 / fontSizes[1],
  heading: 1.15,
}
